import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppDataModelState } from '../reducers/applicationdatamodel.reducer';

export const appDataModelState: any = createFeatureSelector<AppDataModelState>('appDatamodel');

export const appDMSuccData = createSelector(appDataModelState, (state: any) => {
  return state.appDMSuccData;
});

export const appDMFailData = createSelector(appDataModelState, (state: any) => {
  return state.appDMFailData;
});

export const dropFailed = createSelector(appDataModelState, (state: any) => {
  return state.dropFailed;
});

export const dropSucc = createSelector(appDataModelState, (state: any) => {
  return state.dropSucc;
});

export const parTblFailed = createSelector(appDataModelState, (state: any) => {
  return state.parTblFailed;
});

export const parTblSucc = createSelector(appDataModelState, (state: any) => {
  return state.parTblSucc;
});

export const tblTypeFailed = createSelector(appDataModelState, (state: any) => {
  return state.tblTypeFailed;
});

export const tblTypeSucc = createSelector(appDataModelState, (state: any) => {
  return state.tblTypeSucc;
});

export const runtimeWorkflowStatusField = createSelector(appDataModelState, (state: any) => {
  return state.runtimeWorkflowStatusField;
});
